export const GET_BROWSE_ITEMS = 'GET_BROWSE_ITEMS';
export const GET_BROWSE_ITEMS_SUCCESS = 'GET_BROWSE_ITEMS_SUCCESS';
export const GET_BROWSE_ITEMS_ERROR = 'GET_BROWSE_ITEMS_ERROR';
export const RESET_BROWSE_ITEMS = 'RESET_BROWSE_ITEMS';
export const GET_BROWSE_ITEMS_DELAYED = 'GET_BROWSE_ITEMS_DELAYED';

export const SELECT_BROWSE_ITEM = 'SELECT_BROWSE_ITEM';
export const DESELECT_BROWSE_ITEM = 'DESELECT_BROWSE_ITEM';
export const DESELECT_MANY_BROWSE_ITEMS = 'DESELECT_MANY_BROWSE_ITEMS';
export const RESET_BROWSE_ITEMS_ACTIONS = 'RESET_BROWSE_ITEMS_ACTIONS';

export const OPEN_BROWSE_ITEM = 'OPEN_BROWSE_ITEM';
export const CLOSE_BROWSE_ITEM = 'CLOSE_BROWSE_ITEM';

export const SET_BROWSE_ITEMS_FILTERS = 'SET_BROWSE_ITEMS_FILTERS';
export const UPDATE_BROWSE_ITEMS = 'UPDATE_BROWSE_ITEMS';
